export default {
  CLEAR_LOGIN_STORE (state) {
    state.logged = false
  },
  CHANGE_LOGGED (state, payload) {
    state.logged = payload
  },
}
